<template>
  <div class="container-wrapper">
    <div class="containerSection">
      <div class="sectionInternal">
        <dl>
          <dt>
            <img src="../assets/icon4.png" alt="">
          </dt>
          <dd>
            <p>集运转运</p>
            <span>（EMS/DHL/自营专线）</span>
          </dd>
        </dl>
        <div class="synopsis">
          <div class="sectionTop">
            <p>业务介绍</p>
            <div></div>
          </div>
          <div class="account">
            <p><span>集运转运</span>专注海外华人服务,仓库, 配送, 网购中国/ 日本/韩国商品一站式解决</p>
          </div>
        </div>
      </div>
      <div class="transfer-button sectionInternal">
        <div class="button-item" @click="showModal = 1">操作指南</div>
        <div class="button-item" @click="showModal = 2">开始下单</div>
        <div class="button-item" @click="showModal = 3">联系客服</div>
        <div class="button-item" @click="showModal = 4">跳转公众号</div>
      </div>
      <div class="containerImg">
        <div class="container">
          <img src="../assets/img3.png" alt="">
          <P>客户下单</P>
          <P>仓库收货</P>
          <P>包裹入库</P>
          <P>分拣打包粘单</P>
          <P>国际空运</P>
          <P>海关清关</P>
          <P>海关配送</P>
          <P>客户签收</P>
        </div>
      </div>
    </div>
    <div class="spot">
      <div class="sectionTop">
        <p>速派电商仓配业务优势</p>
      </div>
      <div class="spotCont">
        <dl>
          <dt>
            <img src="../assets/icon18.png" alt="">
          </dt>
          <dd>
            <p>多国集运转运</p>
            <p>足不出户可以购买中国日本 韩国优质产品</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon9.png" alt="">
          </dt>
          <dd>
            <p>智能的客服系统</p>
            <p>7*15小时客户服务 信实时推送通知 微信公众号在线客服</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon19.png" alt="">
          </dt>
          <dd>
            <p>专业打包服务</p>
            <p>加固包裹减少包裹重量 压缩包裹体积 为你节约30~50%运费</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon15.png" alt="">
          </dt>
          <dd>
            <p>物品拍照</p>
            <p>您的货物入库和打包阶段 都提供拍照服务 并通过微信主动推送给您</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon16.png" alt="">
          </dt>
          <dd>
            <p>免费验货</p>
            <p>货物到达仓库后我们免费为您验货 并将问题件通过微信主动推送给您 支持退换货</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon17.png" alt="">
          </dt>
          <dd>
            <p>管家服务</p>
            <p>提供一对一服务 为您代购中日韩商品（免服务费）</p>
          </dd>
        </dl>
      </div>
    </div>
    <div class="wrap" v-if="showModal == 1" @click="showModal = false">
      <div class="scroll">
        <div class="article" @click.stop>
          <!--<div class="article-title">-->
            <!--<span>速派集运操作指南</span>-->
          <!--</div>-->
          <div class="article-img">
            <img src="../assets/course.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="wrap" v-if="showModal == 2" @click="showModal = false">
      <div class="qrcode">
        <img src="../assets/miniQrcode.jpg" alt="" class="miniQrcode">
        <div>请您扫描上方小程序码</div>
      </div>
    </div>
    <div class="wrap" v-if="showModal == 3" @click="showModal = false">
      <div class="qrcode">
        <img src="../assets/cargoService.jpg" alt="">
        <div>请您扫描上方二维码，联系客服</div>
      </div>
    </div>
    <div class="wrap" v-if="showModal == 4" @click="showModal = false">
      <div class="qrcode">
        <img src="../assets/transferQrcode.jpg" alt="">
        <div>请您扫描上方二维码，关注公众号</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Container',
    props: {},
    components: {},
    data() {
      return {
        showModal:false
      }
    },
    computed: {},
    methods: {},
    created() {

    },
    mounted() {

    }
  }
</script>
<style scoped lang="scss">
  .containerSection {
    min-height: 250px;
  }

  .sectionInternal {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    /*min-height: 250px;*/
    dl {
      padding: 0 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 80px;
      min-height: 250px;
      width: 300px;
      dt {
        width: 160px;
        height: 130px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
          color: darkkhaki;
        }
      }
      dd {
        p {
          font-size: 23px;
          color: rgb(36, 35, 35);
          text-align: center;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        span {
          font-size: 18px;
          text-align: center;
          color: rgb(36, 35, 35);
        }
      }
    }
    .synopsis {
      width: 560px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .sectionTop {
        align-items: flex-start;
      }
      .account {
        margin-top: 20px;
        p {
          span {
            color: $bg-color;
            font-size: 25px;
            margin-right: 20px;
          }
        }
      }
    }
  }

  .containerImg {
    margin: 40px 0;
    background: #f5f5f5;
    .container {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      p {
        position: absolute;
        top: 48%;
        left: 15%;
        font-size: 10px;
      }
      p:nth-child(3) {
        top: 68%;
        left: 32%;
      }
      p:nth-child(4) {
        top: 27%;
        left: 34%;
      }
      p:nth-child(5) {
        top: 68%;
        left: 45%;
      }
      p:nth-child(6) {
        top: 68%;
        left: 58%;
      }
      p:nth-child(7) {
        top: 27%;
        left: 61%;
      }
      p:nth-child(8) {
        top: 68%;
        left: 71%;
      }
      p:nth-child(9) {
        top: 62%;
        left: 85%;
      }
    }

  }

  .spot {
    width: 1000px;
    margin: 0 auto;
    .spotCont {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      justify-content: space-around;
      dl {
        width: 28%;
        height: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
        dt {
          width: 90px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
        }
        dd {
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          p {
            width: 100%;
            text-align: center;
            font-size: 17px;
            line-height: 30px;
            word-break: break-all;
            height: 30px;
          }
          p:not(:first-child) {
            font-size: 13px;
            flex: 1;
          }

        }
      }
    }
  }

  .transfer-button {
    padding: 0 10px;
    box-sizing: border-box;
    .button-item {
      width: 207px;
      height: 40px;
      background: $bg-color;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      margin-right: 50px;
      cursor: pointer;
      transition: all 0.3s;
    }
    .button-item:nth-last-child(1) {
      margin: 0;
    }
    .button-item:hover {
      opacity: 0.9;
    }
  }

  .wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 40px 0;
    .qrcode{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 300px;
      height: 360px;
      margin: auto;
      background: #ffffff;
      img{
        width: 300px;
        height: 300px;
      }
      div{
        text-align: center;
        line-height: 50px;
      }
      .miniQrcode{
        width: 280px;
        height: 280px;
        margin: 10px;
      }
    }
    .scroll {
      height: auto;
      /*position: relative;*/
      margin-bottom: 40px;
      .article {
        width: 50%;
        min-width: 600px;
        max-width: 800px;
        min-height: 90vh;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        right: 0;
        left: 0;
        margin: 0 auto;
        .article-title {
          height: 60px;
          background: $bg-color;
          color: #fff;
          font-size: 28px;
          text-align: center;
          line-height: 60px;
          font-weight: bold;
          span{
            border: 1px solid #ffffff;
            padding: 0 8px;
          }
        }
        .article-img{
          /*width: 100%;*/
          /*padding: 30px;*/
          img{
            width: 100%;
          }
        }

      }
    }
  }

  ::-webkit-scrollbar {
    width: 0; /*滚动条宽度*/
    height: 0; /*滚动条高度*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    /*border-radius: 10px;  !*滚动条的背景区域的圆角*!*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    /*border-radius: 10px;  !*滚动条的圆角*!*/
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
    background-color: rgba(0, 0, 0, 0); /*滚动条的背景颜色*/
  }


</style>



// WEBPACK FOOTER //
// src/components/Container.vue